<template lang="pug">
  .upload.page
</template>

<script lang="js">

export default {
  name: 'UploadPage',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.upload {

}
</style>
